import { defineRecipe } from '@chakra-ui/react/styled-system';

import { skeletonShimmerAfter } from '../common/skeletonShimmer';

// Matches the v1 Skeleton: a static neutral base with a soft-masked highlight band sweeping
// left→right (a `::after` overlay), rather than animating a two-tone gradient's background-position.

const skeletonRecipe = defineRecipe({
  className: 'skeleton',
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  variants: {
    loading: {
      true: {
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: 'utilities/skeleton',
        borderColor: 'transparent',
        backgroundClip: 'padding-box',
        cursor: 'default',
        color: 'transparent',
        pointerEvents: 'none',
        userSelect: 'none',
        flexShrink: '0',
        // Hide the wrapped content (asChild) and `::before`, but not `::after` — that paints the shimmer.
        '&::before, *': {
          visibility: 'hidden',
        },
        '&::after': skeletonShimmerAfter,
      },
      false: {
        animation: 'fade-in var(--fade-duration, 0.1s) ease-out !important',
      },
    },
  },

  defaultVariants: {
    loading: true,
  },
});

export default skeletonRecipe;
